import React from 'react';
import { Row, Col, Collapse, Stack, Form } from 'react-bootstrap';
import { HpSelect } from '../HpSelect';
import { InputForm } from '../InputForm';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import PatientContactDetails from './PatientContactDetails';
import ExpandedDetails from './ExpandedDetails';
import CollapsedDetails from './CollapsedDetails';
import { usePatientProfile } from '../../hooks';

type PatientInfoDetailsProps = {
  collapsedConfig: any;
  expandedConfig: any;
  patientContactConfig: any;
  freeTextConfig: any;
  handleInputChange: (
    e: any,
    clinicIndex?: number,
    episodeIndex?: number,
  ) => void;
  clinics: any[];
  patientProfileStatus: any;
};

const PatientInfoDetails: React.FC<PatientInfoDetailsProps> = ({
  collapsedConfig,
  expandedConfig,
  patientContactConfig,
  freeTextConfig,
  handleInputChange,
  clinics,
  patientProfileStatus,
}) => {
  const { editProfile, openClinics, openPatientInfo } = usePatientProfile();
  const { patientProfile: normalPatientProfile } = useSelector(
    (state: RootState) => state.patientProfile,
  );

  const patientProfile = normalPatientProfile;

  const latestEpisodeIndex =
    patientProfile.clinics?.[0]?.episodes &&
    patientProfile.clinics?.[0].episodes?.length > 0
      ? patientProfile.clinics?.[0].episodes?.length - 1
      : 0;
  return (
    <>
      {/* Collapsed Config */}
      <CollapsedDetails
        collapsedConfig={
          collapsedConfig?.length > 0 && collapsedConfig?.[0].data
            ? collapsedConfig[0].data
            : []
        }
        clinics={clinics}
        handleInputChange={handleInputChange}
        patientProfileStatus={patientProfileStatus}
      />

      {/* Multiple Clinic Collapse */}
      <div>
        <Collapse in={openClinics}>
          <div id="multiple-clinics" className="mb-4 mt-4">
            {patientProfile.clinics?.map((clinic: any, i: number) => (
              <div id={`clinic-${i}`} key={i}>
                <Stack direction="horizontal" gap={2} className="labelRow">
                  <Form.Label className="labelBold">Clinic</Form.Label>
                  <Form.Label className="labelSimple">
                    {clinic.clinic}
                  </Form.Label>
                </Stack>
                <Row>
                  <Col lg={{ span: 3, offset: 1 }}>
                    <Stack direction="horizontal" gap={2} className="labelRow">
                      <Form.Label className="labelBold">Episode</Form.Label>
                      {!editProfile && (
                        <Form.Label className="labelSimple">
                          {clinic.episode_closed ? 'Closed' : 'Open'}
                        </Form.Label>
                      )}
                      {editProfile && (
                        <Form.Select
                          className="form-select-xs"
                          onChange={(e) => handleInputChange(e, i)}
                          name="episodeClosed"
                          id="episodeClosed"
                          defaultValue={clinic.episode_closed}
                        >
                          <option value="false">Open</option>
                          <option value="true}">Closed</option>
                        </Form.Select>
                      )}
                    </Stack>
                  </Col>
                  <Col sm="4">
                    <HpSelect
                      label="Health prof."
                      editProfile={editProfile}
                      patientProfileStatus={patientProfileStatus}
                      clinic={clinic}
                      onInputChange={(e: any) => handleInputChange(e, i)}
                      healthProfessionals={
                        clinics.find((x) => x.clinic_id === clinic.id)?.episodes
                          ?.details?.healthProfessionals ?? []
                      }
                    />
                  </Col>
                  <Col sm="4">
                    <Stack direction="horizontal" gap={2} className="labelRow">
                      <Form.Label className="labelBold">Team</Form.Label>
                      <Form.Label className="labelSimple">
                        {clinic?.episodes?.primary_teams ?? '-'}
                      </Form.Label>
                    </Stack>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </Collapse>
      </div>

      {/* More Details Patient Collapse */}
      <div>
        <Collapse in={openPatientInfo}>
          <div id="more-details" className="mt-1">
            <ExpandedDetails
              expandedConfig={
                expandedConfig?.length > 0 && expandedConfig?.[0].data
                  ? expandedConfig[0].data
                  : []
              }
              clinics={clinics}
              handleInputChange={handleInputChange}
              patientProfileStatus={patientProfileStatus}
            />
            {patientContactConfig?.length > 0 && (
              <PatientContactDetails
                patientContactConfig={
                  patientContactConfig?.length > 0 &&
                  patientContactConfig[0].data
                    ? patientContactConfig[0].data
                    : []
                }
                handleInputChange={handleInputChange}
                clinics={clinics}
                patientProfileStatus={patientProfileStatus}
              />
            )}
            <InputForm
              editable={editProfile}
              titles={freeTextConfig}
              // onClinicMetaChange={handleClinicMetaChange}
              handleInputChange={(e: any) =>
                handleInputChange(e, 0, latestEpisodeIndex)
              }
              clinic={patientProfile.clinics?.[0]}
              episode={
                patientProfile.clinics?.[0].episodes?.[latestEpisodeIndex]
              }
              // initialPatientProfile={patientProfile}
            />
          </div>
        </Collapse>
      </div>
    </>
  );
};

export default PatientInfoDetails;
